import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { ComponentDefinition } from '@formbird/types';
import { ChangedDocumentService } from 'formbird-services';
import { FormbirdInjectorService } from '@services/injector/formbird-injector.service';
import { SearchService } from '@services/search/search.service';
import { ComponentSetupService } from '../../../../formbird-sc-shared/src/lib/component-setup.service';
import { AbstractComponent } from '../../../../formbird-sc-shared/src/lib/components/abstract.component';
import { GStaticChartService } from './gstatic-chart.service';

interface GanttChartComponentDefinition extends ComponentDefinition {
  filter?: any;
  statusField?: any;
  taskStartDateField?: any;
  taskDurationField?: any;
  taskDurationTimeUnit?: any;
}

@Component({
  templateUrl: './gantt-chart.component.html',
  styleUrls: ['./gantt-chart.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GanttChartComponent extends AbstractComponent<GanttChartComponentDefinition> implements OnInit {

  @Input() docs: object = {};

  @ViewChild('elemChart', {static: false}) elemChart: ElementRef;

  hideRequired: boolean;
  isRequired: boolean;

  //
  ganttChartRowHeight = 42;
  filter: any = {};
  statusField = '';
  taskStartDateField = new Date();
  taskDurationField = '';
  taskDurationTimeUnit = 'hours';
  filterObj;
  options;
  google;
  chartData = [];

  constructor(
    protected formbirdInjectorService: FormbirdInjectorService,
    protected cd: ChangeDetectorRef,
    protected changedDocumentService: ChangedDocumentService,
    protected componentSetupService: ComponentSetupService,
    private searchService: SearchService,
    private gStaticChartService: GStaticChartService
  ) {
    super(formbirdInjectorService, changedDocumentService, componentSetupService, cd);
  }

  ngOnInit() {
    this.componentSetupService.setupStandardProperties(this);

    if (!( typeof this.componentDefinition.filter === 'undefined' || this.componentDefinition.filter === null) ) {
      this.filter = this.componentDefinition.filter;
    }
    this.filterObj = {};
    if (this.filter) {
      this.filterObj = JSON.parse(this.filter.replace(/'/g, '"'));
      // Secure the sort object to be empty, avoid adding duplicate sort fields
    }
    if (this.filterObj.sort === undefined || this.filterObj.sort.length > 0) {
      this.filterObj.sort = [];
    }
    if (!( typeof this.componentDefinition.statusField === 'undefined' || this.componentDefinition.statusField === null) ) {
      this.statusField = this.componentDefinition.statusField;
    }
    if (this.statusField !== '') {
      const sortObj = {};
      sortObj[this.statusField] = 'asc';
      this.filterObj.sort.push(sortObj);
    }
    this.options = {
      document: this.document,
      filter: {},
      includeDeleted: false,
      searchOfflineOnly: false
    };
    this.options.filter = this.filterObj;

    if (!( typeof this.componentDefinition.taskStartDateField === 'undefined' || this.componentDefinition.taskStartDateField === null) ) {
      this.taskStartDateField = this.componentDefinition.taskStartDateField;
    }
    if (!( typeof this.componentDefinition.taskDurationField === 'undefined' || this.componentDefinition.taskDurationField === null) ) {
      this.taskDurationField = this.componentDefinition.taskDurationField;
    }
    if (!( typeof this.componentDefinition.taskDurationTimeUnit === 'undefined'
     || this.componentDefinition.taskDurationTimeUnit === null) ) {
      this.taskDurationTimeUnit = this.componentDefinition.taskDurationTimeUnit;
    }

    this.initializeFieldValue();

    if (!(typeof this.componentDefinition.mandatory === 'undefined' || this.componentDefinition.mandatory === null)) {
      this.isRequired = this.componentDefinition.mandatory;
    } else {
      this.isRequired = false;
    }
    this.hideRequired = !this.isRequired;
    this.componentDefinition = this.template.components[this.key];

    //
    this.loadChart(() => {
      console.log('GStatic chart loaded');
      this.searchService.search(this.options).then((data) => {
        this.chartData = [];
        if (data && data.data && data.data.hits && data.data.hits.hits) {
          this.chartData = data.data.hits.hits;
        }
        this.google.charts.load('current', { packages: ['gantt']});
        this.google.charts.setOnLoadCallback(this.drawChart.bind(this));
      });
    });
  }

  initializeFieldValue() {
    if ((this.document && this.document[this.componentDefinition.name])) {
      this.docs[this.fieldName] = this.document[this.componentDefinition.name];
      this.fieldValue = this.document[this.componentDefinition.name];

    }
  }

  //
  daysToMilliseconds(days) {
    return days * 24 * 60 * 60 * 1000;
  }
  toMilliseconds(minutes) {
    return minutes * 60 * 1000;
  }
  loadChart(cb) {
    this.gStaticChartService.load().then( google => {
      this.google = google;
      console.log('**** load gstatic chart done ************');
      if (cb && typeof cb === 'function') {
        cb();
      }
    }).catch(error => console.log(error));
  }
  drawChart() {
    const data = new this.google.visualization.DataTable();
    data.addColumn('string', 'Task ID');
    data.addColumn('string', 'Task Name');
    data.addColumn('date', 'Start Date');
    data.addColumn('date', 'End Date');
    data.addColumn('number', 'Duration');
    data.addColumn('number', 'Percent Complete');
    data.addColumn('string', 'Dependencies');

    const rows = [];
    this.chartData.forEach((hit) => {
      const src = hit._source;
      if(typeof src.actionDate !== 'undefined' && src.actionDate !== null) {
        rows.push([src.documentId, src.systemHeader.summaryName,  new Date(src.actionDate), null, this.daysToMilliseconds(10), 100,  null]);
      }
    });
    data.addRows(rows);

    const options = {
      height: this.ganttChartRowHeight * rows.length + 100,
      gantt: {
        defaultStartDateMillis: new Date(this.taskStartDateField)
      }
    };

    const chart = new this.google.visualization.Gantt(this.elemChart.nativeElement);
    chart.draw(data, options);
  }
}
